export const DEFAULT_ROLES = {
  UNKNOWN: "unknown",
  CMS_ADMIN: "cmsAdmin",
  SITE_ADMIN: "siteAdmin",
  MANAGER: "manager",
  SAFETY_ADMIN: "safetyAdmin",
  WORKER: "worker",
  FRONT_LINE: "frontline",
  OTHER_OFFICE_STAFF: "otherOfficeStaff",
  FRONT_LINE_SUPERVISOR: "frontlineSupervisor",
};

export const APP_USER_ROLES = [
  DEFAULT_ROLES.WORKER,
  DEFAULT_ROLES.FRONT_LINE_SUPERVISOR,
  DEFAULT_ROLES.SAFETY_ADMIN,
  DEFAULT_ROLES.SITE_ADMIN,
  DEFAULT_ROLES.MANAGER,
  DEFAULT_ROLES.OTHER_OFFICE_STAFF,
];

export const QUERY_TYPES = {
  PAGE: "page",
  SORT: "sort",
  FILTER: "filter",
  TAB: "tab",
};

export const POINT_TYPES = {
  SAFETY_POINT: "safetyPoint",
  REWARD_POINT: "rewardPoint",
};

export const POINT_ITEM_TYPES = [
  POINT_TYPES.SAFETY_POINT,
  POINT_TYPES.REWARD_POINT,
];

export const POINT_ACTIONS = {
  CREDIT: "credit",
  DEBIT: "debit",
};

export const POINT_ITEM_ACTIONS = [POINT_ACTIONS.CREDIT, POINT_ACTIONS.DEBIT];

export const DEFAULT_STATUS = {
  PENDING: "pending",
  PENDING_APPROVAL: "pendingApproval",
  ACTIVE: "active",
  INACTIVE: "inactive",
  SUSPENDED: "suspended",
  COMPLETED: "completed",
  REJECTED: "rejected",
  APPROVED: "approved",
  SUBMITTED: "submitted",
  CONFIRMED: "confirmed",
  DELIVERED: "delivered",
  CANCELLED: "cancelled",
  TAKEN_DOWN: "takenDown", // FrontEnd
  SUCCESS: "success",
  FAIL: "fail",
  VOIDED: "voided",
  PENDING_TO_VOID: "pendingToVoid",
  APPROVE: "approve",
  REJECT: "reject",
  PROCESSING: "processing",
  CLEARED: "cleared",
  FAILED: "failed",
  ERROR: "error",
};

export const COMMON_STATUS = [DEFAULT_STATUS.ACTIVE, DEFAULT_STATUS.INACTIVE];

export const SUPPORTED_LANGUAGE = [
  {
    value: "en",
    label: "English",
  },
  {
    value: "zh",
    label: "繁體中文",
  },
  {
    value: "zhCHS",
    label: "简体中文",
  },
];

export const GENDER = [
  {
    label: "Female",
    value: "f",
  },
  {
    label: "Male",
    value: "m",
  },
];

// Tags
export const ACCEPTED_SRC_TYPES = {
  SUBCONTRACTOR: "SubContractor",
  POINT_ITEM: "PointItem",
  COMPANY: "Company",
  CONSTRUCTION_SITE: "ConstructionSite",
};

export const REF_TYPES = {
  CONSTRUCTION_SITE: "ConstructionSite",
  COMPANY: "Company",
};

export const TAG_SLUGS = {
  SUBCONTRACTOR_CONSTRUCTION_SITES: "subcontractor-construction-sites",
  COMPANIES: "companies",
  PROJECT_TYPE: "project-type",
};

export const CATEGORY = {
  COURSE: "course",
  TRAINING: "training",
};

export const STOCK_STATUS = {
  IN_STOCK: "inStock",
  LOW_STOCK: "lowStock",
  OUT_OF_STOCK: "outOfStock",
};

export const ROLE_ASSIGNMENT = {
  SUPERVISOR: "supervisor",
};

export const BREACH_RECORD_STATUS = {
  PENDING_FOR_ENROLMENT: "pendingForEnrolment",
  PENDING_FOR_UPLOAD_CERTIFICATE: "pendingForUploadCertificate",
  PENDING_FOR_CERTIFICATE_APPROVAL: "pendingForCertificateApproval",
  CERTIFICATE_APPROVED: "certificateApproved",
  BLOCKED_BY_GATE: "blockedByGate",
  CLEARED: "cleared",
  MANUALLY_CLEARED: "manuallyCleared",
};

export const ACCESS_STATUS = {
  BLOCKED: "blocked",
  UNBLOCKED: "unblocked",
};

export const BREACH_RECORD_ACTION = {
  CANCEL_ENROLMENT: "cancelEnrolment",
  UPLOAD_CERTIFICATE: "uploadCertificate",
  REJECT_CERTIFICATE: "rejectCertificate",
  APPROVE_CERTIFICATE: "approveCertificate",
  UPLOAD_ENROLMENT_PROOF: "uploadEnrolmentProof",
  BALANCE_BELOW_THRESHOLD: "balanceBelowThreshold",
  BALANCE_ABOVE_THRESHOLD: "balanceAboveThreshold",
  BLOCK_USER: "blockUser",
  UNBLOCK_USER: "unblockUser",
  GATE_BLOCK_USER: "gateBlockUser",
  GATE_UNBLOCK_USER: "gateUnblockUser",
};

export const COMPANY_TYPE = {
  CLIENT: "client",
  // MAIN_CON_OWNER: "mainContractorOwner",
  MAIN_CON: "mainContractor",
};

export const SOURCE = {
  APP: "app",
  IMPORT: "import",
  CMS: "cms",
  SYSTEM: "system",
  NULL: null,
};

export const USER_BLACKLIST_STATUS = {
  BLACKLISTED: "blacklisted",
  REMOVED: "removed",
};

export const BLACKLIST_STATUS = {
  ACTIVE: "active",
  REMOVED: "removed",
};
